'use client';

import { clsx } from 'clsx';
import { useTranslation } from '@crehana/i18n';
import Avatar from "../../Avatar/Avatar";
import { Popper, PopperContent, PopperTrigger } from "../Popper";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../Tooltip";
import locales, { AVATAR_GROUP } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var AvatarGroup = function AvatarGroup(_ref) {
  var avatars = _ref.avatars,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    hideLabel = _ref.hideLabel,
    _ref$containerAvatars = _ref.containerAvatarsClass,
    containerAvatarsClass = _ref$containerAvatars === void 0 ? 'tw-bg-neutral-light-100 tw-rounded-full tw-px-0.8 tw-py-0.2 tw-border-solid tw-border  tw-border-neutral-light-400' : _ref$containerAvatars,
    _ref$removePortalFrom = _ref.removePortalFromPopper,
    removePortalFromPopper = _ref$removePortalFrom === void 0 ? false : _ref$removePortalFrom,
    label = _ref.label;
  var _useTranslation = useTranslation(AVATAR_GROUP),
    addResourceBundle = _useTranslation.addResourceBundle,
    t = _useTranslation.t;
  addResourceBundle(locales);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: avatars.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!hideLabel && /*#__PURE__*/_jsxs("div", {
        className: "tw-mb-1",
        children: [/*#__PURE__*/_jsx("span", {
          className: "tw-font-link1 tw-mr-0.4",
          children: label || t('MEMBERS')
        }), /*#__PURE__*/_jsxs("span", {
          className: "tw-font-body5 tw-text-neutral-light-700",
          children: ["(", avatars.length, ")"]
        })]
      }), /*#__PURE__*/_jsx(Popper, {
        children: /*#__PURE__*/_jsxs("div", {
          className: clsx('tw-flex  tw-w-fit', containerAvatarsClass),
          children: [avatars.slice(0, 4).map(function (avatar, index) {
            return /*#__PURE__*/_jsx("div", {
              className: clsx('tw-cursor-pointer tw-border-solid tw-border-0.4 tw-border-neutral-light-100 tw-rounded-full tw-relative', index != 0 && 'tw-ml-[-1.4rem]'),
              children: /*#__PURE__*/_jsx(TooltipProvider, {
                children: /*#__PURE__*/_jsxs(Tooltip, {
                  delayDuration: 500,
                  children: [/*#__PURE__*/_jsx(TooltipTrigger, {
                    className: "tw-text-neutral-light-800 dark:tw-text-neutral-light-100",
                    children: /*#__PURE__*/_jsx(Avatar, {
                      size: size,
                      src: avatar.src
                    })
                  }), /*#__PURE__*/_jsx(TooltipContent, {
                    align: "center",
                    side: "top",
                    children: avatar.userName
                  })]
                })
              })
            }, avatar.userName);
          }), /*#__PURE__*/_jsx(PopperTrigger, {
            type: "button",
            className: "tw-z-1",
            children: avatars.length > 4 && /*#__PURE__*/_jsxs("span", {
              className: " tw-ml-[-14px] tw-static tw-outline tw-outline-neutral-light-100 tw-font-link1 tw-text-neutral-light-700 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-solid tw-border tw-border-neutral-light-500 tw-h-3.2 tw-w-3.2 tw-bg-neutral-light-300 tw-cursor-pointer",
              children: ["+", avatars.length - 4]
            })
          }), /*#__PURE__*/_jsx(PopperContent, {
            align: 'center',
            side: 'bottom',
            className: "tw-py-1.2 tw-px-1.6 tw-h-16.4 tw-overflow-auto tw-max-w-24",
            removePortal: removePortalFromPopper,
            children: /*#__PURE__*/_jsx("div", {
              className: "tw-space-y-1.2",
              children: avatars.slice(4, avatars.length).map(function (avatar, index) {
                return /*#__PURE__*/_jsxs("div", {
                  className: "tw-flex tw-items-center",
                  children: [/*#__PURE__*/_jsx(Avatar, {
                    size: size,
                    src: avatar.src
                  }), /*#__PURE__*/_jsx("span", {
                    className: "tw-font-body5 tw-ml-0.8 tw-truncate",
                    children: avatar.userName
                  })]
                }, index);
              })
            })
          })]
        })
      })]
    })
  });
};